<script>
import {mapState} from 'vuex'


export default {
    data() {
        return {            
            list: null,
        }
    },

    props: [
    ],


    computed: {
        
    },

    created() {

    },

    mounted() {        
        //this.getList();
    },

    watch: {
    },

    methods: {
        getList() {
            axios
                .get(this.listUrl,
                    {
                        params: {
                            
                        }
                    }
                )
                .then(response => {
                    this.list = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                });

        },
    },
}
</script>
